import { AuthService } from "../resource";

const AuthModule = {
  namespaced: true,
  state: {
    datas: [],
    user: {
      id: "",
      fname: "",
      lname: "",
      nick_name: "",
      email: "",
      group: "",
      phone:"",
      roles:"",
      enterprise_id: "",
      enterprise_name: "",
      team_id: "",
      team_name: "",
	  sale_channel_id: "",
      sale_channel_name: "",
    },
	locale:"th"
  },
  mutations: {
	SET_LOCALE(state, data) {
		state.locale = data;
	  },
    SET_DATA(state, data) {
      state.datas = data;
    },
    SET_PROFILE(state, data) {
      state.user.fname = data.fname;
      state.user.lname = data.lname;
      state.user.nick_name = data.nick_name;
      state.user.phone = data.phone;
	},
    SET_USER(state, data) {
	  state.user = {}
      state.user.id = data.Id;
      state.user.fname = data.FirstName;
      state.user.lname = data.LastName;
      state.user.nick_name = data.NickName;
      state.user.phone = data.Phone;
      state.user.email = data.Email;
      state.user.group = data.GroupId;
      state.user.enterprise_id = data.EnterpriseID;
      state.user.enterprise_name = data.EnterpriseName;
      state.user.status = data.Status;
      state.user.team_id = data.TeamID;
      state.user.team_name = data.TeamName;
      state.user.sale_channel_id = data.SaleChannelID;
      state.user.sale_channel_name = data.SaleChannelName;
      state.user.roles = JSON.parse(data.Roles);
    },
    CLEAR_USER(state, data) {
      state.user.id = "";
      state.user.fname = "";
      state.user.lname = "";
      state.user.nick_name = "";
      state.user.phone = "";
      state.user.email = "";
      state.user.group = "";
      state.user.status = "";
      state.user.team_id = "";
      state.user.team_name = "";
      state.user.sale_channel_id = "";
      state.user.sale_channel_name = "";
      state.user.roles = "";
      state.user.enterprise_id = "";
      state.user.enterprise_name = "";
    }
  },
  actions: {
    
    ForgotPassword({ commit, state }, data) {
      return AuthService.ForgotPassword(data);
    },
    ResetPassword({ commit, state }, data) {
      return AuthService.ResetPassword(data);
    },
    setUser({ commit, state }, data) {
      commit("SET_USER", data);
    },
	setProfile({ commit, state }, data) {
		console.log(data)
      commit("SET_PROFILE", data);
	},
    createData({ commit, state }, data) {
      return AuthService.AuthCreate(data);
    },
    updateData({ commit, state }, data) {
      return AuthService.AuthUpdate(data);
    },
    deleteData({ commit, state }, data) {
      return AuthService.AuthDelete(data);
    },
    getProfile({ commit, state }, data) {
      return AuthService.GetProfile(data);
    },
    changeProfile({ commit, state }, data) {
      return AuthService.ChangeProfile(data);
    },
    changePassword({ commit, state }, data) {
      return AuthService.ChangePassword(data);
    },
    async SignIn({ commit, state }, data) {
      return await AuthService.SignIn(data);
    },
    async listData({ commit, state }) {
      try {
        const data = await AuthService.AuthList();
        if (data.data.Data == null) {
          commit("SET_DATA", []);
        } else {
          commit("SET_DATA", data.data.Data);
        }
      } catch (err) {
        commit("SET_DATA", []);
      }
    },
    async signOut({ commit, state }) {
      try {
        const data = await AuthService.SignOut();
        commit("CLEAR_USER", state.user);
      } catch (err) {
        commit("CLEAR_USER", state.user);
      }
    },
	setLocale({ commit, state }, locale) {
        commit("SET_LOCALE", locale);
	}
  },
  getters: {
    getData(state) {
      return state.datas;
    },
	getLocale(state) {
		return state.locale;
	},
    getUser(state) {
      return state.user;
    },


    isAuthenticate(state) {
		try {
			return state.user.id != "";
		} catch {
			return false;
		}
    },

	isAccessWms(state) {
		return state.user.roles.wms > 0;
	},

	isAccessOrder(state) {
		return state.user.roles.order > 0;
	},

	isAccessPayment(state) {
		return state.user.roles.payment > 0;
	},

	isAccessProduct(state) {
		return state.user.roles.product > 0;
	},

	isAccessPacking(state) {
		return state.user.roles.packing > 0;
	},

	isAccessReport(state) {
		return state.user.roles.report > 0;
	},

	isAccessDelivery(state) {
		return state.user.roles.delivery > 0;
	},

	isAccessPlatform(state) {
		return state.user.roles.paltfrom > 0;
	},

	isAccessCustomer(state) {
		return state.user.roles.customer > 0;
	},

	isAccessExpress(state) {
		return state.user.roles.express > 0;
	},

	isAccessOrderReturn(state){
		return state.user.roles.order_return > 0;
	},

	isAdmin(state) {
		return state.user.group == 1;
	},

	isOwner(state) {
		return state.user.group == 2;
	},

	isEmployee(state) {
		return state.user.group == 3;
	},

	isAgent(state) {
		return state.user.group == 4;
	},

	isExpress(state) {
		return state.user.group == 5;
	},

	isCustomer(state) {
		return state.user.group == 6;
	},

	isAccessTiktok(state) {
		return state.user.group == 1;
	},

	


	// Access By Role
	// wms
	// order : {read , write , all}
	// packing { packing,round}




  }
};

export default AuthModule;
